var map = {
	"./android-chrome-192x192.png": 653,
	"./android-chrome-512x512.png": 99869,
	"./apple-touch-icon.png": 4514,
	"./favicon-16x16.png": 62141,
	"./favicon-32x32.png": 28557,
	"./favicon.ico": 34206,
	"./favicon.svg": 42239,
	"./safari-pinned-tab.svg": 28574,
	"./site.webmanifest": 82723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55381;